import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_ARTENUMREF_SCHEMA_LITERAL = {
    title: 'Schéma ArtEnumRefs',
    description: 'Décrit les déclinaisons de gamme avec informations de références',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        AR_REF: { type: 'string' },
        AG_NO1: { type: 'number' },
        AG_NO1LIB: { type: 'string' },
        AG_NO2: { type: 'number' },
        AG_NO2LIB: { type: 'string' },
        AE_REF: { type: ['string', 'null'] },
        AE_PRIXACH: { type: ['number', 'null'] },
        AE_CODEBARRE: { type: ['string', 'null'] }
    },
    required: [ 'CBMARQ', 'AR_REF', 'AG_NO1', 'AG_NO2' ] //
} as const;

const schemaTyped = toTypedRxJsonSchema(F_ARTENUMREF_SCHEMA_LITERAL);
export type RxFArtEnumRefDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_ARTENUMREF_SCHEMA: RxJsonSchema<RxFArtEnumRefDocumentType> = F_ARTENUMREF_SCHEMA_LITERAL;
